import { Outlet, useLocation } from 'react-router-dom'
import { Box, Container, styled } from '@mui/material'

import { Header, HeaderIndex, Footer } from '../shared'

const Layout = styled(Box)(({ theme }) => ({
    height: '100vh',
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    position: 'relative'
}))

const Main = styled(Box)(({ theme }) => ({
    overflowY: 'auto',
    display: 'flex',
    flex: 1
}))

const LayoutBase = () => {
    const location = useLocation()    
    return (
        <Layout>
            { location.pathname === '/' ? (
                <HeaderIndex />
            ) : (
                <Header />
            )}
            <Main>
                <Container>
                    <Outlet />
                </Container>
            </Main>
            <Footer />
        </Layout>
    )
}

export default LayoutBase
